import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';
import Routes from './routes.js'


Vue.use(VueRouter);

const router = new VueRouter ({
    routes: Routes,
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            // Keep scroll position when using browser buttons
            return savedPosition
        }
        else {
            return { x: 0, y: 0 }
        }
    }

});


Vue.config.productionTip = false

new Vue({
  render: h => h(App),
    router,

}).$mount('#app')
